<template>
	<div
		class="content-toggle"
	>
		<button
			type="button"
			class="btn--no-style content-toggle__button"
			:class="{ 'content-toggle__active' : isPreview }"
			@click="$eventBus.$emit('previewToggle', true);"
		>
			<div>Preview Content</div>
		</button>
		<button
			type="button"
			class="btn--no-style content-toggle__button"
			:class="{ 'content-toggle__active' : !isPreview }"
			@click="$eventBus.$emit('previewToggle', false);"
		>
			<div>Manage Content</div>
		</button>
	</div>
</template>

<script>
// Styles
import '@/sass/components/_content-toggle.scss';

export default {
	props: ['isPreview']
};
</script>
